<template>
  <v-btn
    variant="outlined"
    class="tad-btn-secondary text-none"
    :class="{ 'tad-btn-secondary--inline': !block }"
    :block="block"
    :disabled="disabled"
    v-bind="$attrs"
  >
    <slot />
  </v-btn>
</template>

<script>
export default {
  name: "TicketActionSecondaryButton",
  inheritAttrs: false,
  props: {
    block: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
  },
};
</script>
